import { render, staticRenderFns } from "./AboutSection.vue?vue&type=template&id=21683919&scoped=true&"
import script from "./AboutSection.vue?vue&type=script&lang=ts&"
export * from "./AboutSection.vue?vue&type=script&lang=ts&"
import style0 from "./AboutSection.vue?vue&type=style&index=0&id=21683919&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21683919",
  null
  
)

export default component.exports